/**
 * The vendor console's paths. Deferred, but served on the CUSTOMER host: a vendor is a
 * member of the public who signed up to sell, not somebody inside the company (founder
 * decision 2026-09-18).
 *
 * Read eagerly by `apps/web/src/business-os.ts`, which is why this file holds nothing but
 * strings and one `import()`: the router has to know these paths before anyone opens the
 * group, and `routes.tsx` must stay behind the `import()` so the group stays off the
 * customer's first load. A path mounted in `routes.tsx` and not listed here — or listed
 * here and no longer mounted — fails `apps/web/src/__tests__/app-shell.test.ts`.
 */
import type { DeferredGroup } from '../../business-os.js';

export const group: DeferredGroup = {
  host: 'customer',
  paths: [
    '/vendor',
    '/vendor/apply',
    '/vendor/verify',
    '/vendor/listings/new',
    '/vendor/payouts',
    '/vendor/orders',
    '/vendor/listings',
    '/vendor/availability',
    '/vendor/customers',
    '/vendor/ratings',
  ],
  load: () => import('./routes.js').then((m) => m.vendorRoutes),
};
